import React, { useEffect, useState } from 'react';
import Timeline from 'deltoid/core/Timeline';
import { H, Small, Caption } from 'deltoid/core/Blocks/Typography';
import { SpinLoader } from 'deltoid/core/Loaders';
import { QuestionMark } from '../SvgComponents';

import { getTimelineStatusMap, getSkippedSteps } from '../../utils/common';
import Cookies from 'universal-cookie';
import '../../assets/stylesheets/timeline.scss';
const defaultConfig = {
  steps: [
    { id: 'pan-details' },
    { id: 'business-details' },
    { id: 'bank-details' },
    { id: 'signing-authority' },
    { id: 'website-details' },
    { id: 'kyc' },
    { id: 'additional-documents' },
  ],
};

const VerificationTimeline = ({
  statusTimelineEndpoint,
  authToken,
  mid,
  product,
  uiConfig = defaultConfig,
  attachedConfigs: attachedConfigsProp,
  statusIcons,
  refreshSignal,
  onboardingBaseUrl,
  vertical,
  onChange,
  gmv,
  displayGmv,
  isReKYC = false,
  isOnboardingCompleted,
  stopOnboardingFlag,
}) => {
  const [timeline, setTimeline] = useState(false);
  const [settlementActive, setSettlementActive] = useState(false);
  const [agreementSentNotEsigned, setAgreementSentNotEsigned] = useState(false);
  const [status, setStatus] = useState(null);
  useEffect(() => {
    refreshStatus();
  }, []);

  useEffect(() => {
    refreshStatus();
  }, [refreshSignal]);

  const refreshStatus = async () => {
    const response = await fetch(statusTimelineEndpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
        mid: `${mid}`,
        product: `${product}`,
      },
    });
    const dataFetched = response.status === 200 || true;
    const jsonResponse = await response.json();
    setStatus(jsonResponse?.timeline_status);
    if (dataFetched && uiConfig) {
      comppileTimelineState(jsonResponse);
      if (onChange) onChange(jsonResponse);
    }
  };

  const comppileTimelineState = (apiResponse) => {
    const { timeline_status: timeline_Status } = apiResponse;
    const { re_kyc_timeline_status: reKYCStatus } = apiResponse;
    const timelineStatus = isReKYC ? reKYCStatus : timeline_Status;
    const { steps } = uiConfig;
    let timeline = [];
    let inCompleteBtnAdded = false;
    const skippedList = getSkippedSteps({
      attachedConfigs: attachedConfigsProp || [],
    });
    if (steps && steps.length > 0 && timelineStatus) {
      steps.map((step) => {
        const timelineStatusMap = getTimelineStatusMap({ stepId: step.id });
        if (
          skippedList.indexOf(step.id) == -1 &&
          timelineStatusMap &&
          timelineStatus[timelineStatusMap.key]
        ) {
          let subTitle = null;
          let body = null;
          if (timelineStatus[timelineStatusMap.key].status === 'IN_PROGRESS') {
            subTitle = 'VERIFICATION IN PROGRESS';
          }
          if (timelineStatus[timelineStatusMap.key].status === 'FAILURE') {
            subTitle = 'FAILURE';
          }
          if (
            !inCompleteBtnAdded &&
            ['PENDING', 'LOCKED'].includes(
              timelineStatus[timelineStatusMap.key].status
            ) && !stopOnboardingFlag
          ) {
            inCompleteBtnAdded = true;
            body = (
              <a
                href={`${onboardingBaseUrl ? onboardingBaseUrl : ''}#${
                  step.id
                }`}
                className='timeline-undelined'
                target={onboardingBaseUrl ? '_blank' : '_self'}
              >
                Complete Now
              </a>
            );
          }
          timeline = timeline.concat({
            title: timelineStatusMap.title,
            stepIcon: statusIcons[timelineStatus[timelineStatusMap.key].status],
            subTitle,
            body,
          });
        }
      });
    }
    if (timelineStatus) {
      setSettlementActive(
        timelineStatus.settlement_status &&
          timelineStatus.settlement_status.status == 'COMPLETED'
      );
      setAgreementSentNotEsigned(
        timelineStatus.agreement_status &&
          timelineStatus.agreement_status.status == 'IN_PROGRESS'
      );
    }
    setTimeline(timeline.length ? timeline : false);
  };

  const renderProgressBar = () => {
    let gmvAmount = Math.floor(gmv || 0),
      widthPercentage = Math.floor((gmvAmount * 100) / 4000);
    return displayGmv ? (
      <div className='progress-bar-contnr'>
        <span className='bar-text'>
          <span className='left'>Your Payment Limitation</span>
          <span className='qstn-mrk left'>
            <QuestionMark />
          </span>
        </span>
        <div className='progress-bar'>
          <span className='left-txt'>0</span>
          <span className='right-txt'>&#8377; 4000</span>
          &#8377; 2000
          <div className='bar'>
            <span
              className='progress'
              style={{ width: `${widthPercentage}%` }}
            ></span>
          </div>
        </div>
      </div>
    ) : (
      <></>
    );
  };
  let cookies = new Cookies();
  const testMid = cookies.get('test_mid');

  return (
    <>
      <div
        className={`verification-timeline-container ${
          !timeline ? 'loader-center' : ''
        }`}
      >
        {timeline ? (
          <div>
            <div className='mid-heading'>
              <Caption className='timeline-mid'>
                Merchant ID: {mid}&nbsp;&nbsp;
              </Caption>
              {testMid ? (
                <Caption className='timeline-mid'>Test ID: {testMid}</Caption>
              ) : (
                ''
              )}
            </div>
            <H level={5} variant='bold' className=''>
              {isReKYC
                ? 'Periodic KYC update'
                : isOnboardingCompleted || settlementActive
                ? 'Congratulations, your KYC is  complete. You can now receive limit free settlements in your account'
                : 'Your account is active. Complete your full KYC'}
            </H>
            {isReKYC ? (
              <Caption className='mt-1 mb-3'>
                Complete and submit the form to update your latest KYC details.
              </Caption>
            ) : (
              !(isOnboardingCompleted || settlementActive) &&
              status?.bank_status?.status == 'COMPLETED' &&
              status?.pan_status?.status == 'COMPLETED' && (
                <div className='timeline-hint-box'>
                  <Small className='timeline-dark-text'>
                    Please note that your current transaction limit to
                    experience PayU to collect payments is INR 4000 for test
                    purpose. Complete your KYC to access limitless transactions
                    and enable settlements on your account.
                  </Small>
                </div>
              )
            )}
            {agreementSentNotEsigned && (
              <div className='timeline-hint-box blue-nudge'>
                <Small className='timeline-light-text'>
                  Hey, Your Service agreement is ready for you to E-Sign and
                  activate account.
                  <a
                    href={`${
                      onboardingBaseUrl ? onboardingBaseUrl : ''
                    }#service-agreement`}
                    className='timeline-undelined white'
                    target={onboardingBaseUrl ? '_blank' : '_self'}
                  >
                    Proceed to E sign
                  </a>
                </Small>
              </div>
            )}
            <Timeline
              data={timeline}
              variant={'vertical'}
              vertical={vertical}
            />
          </div>
        ) : (
          <SpinLoader />
        )}
      </div>
      {renderProgressBar()}
    </>
  );
};

export default VerificationTimeline;
